//For Authentication...
export const LOGIN_POST_REQUEST= "LOGIN_POST_REQUEST";
export const LOGIN_POST_SUCCESS= "LOGIN_POST_SUCCESS";
export const LOGIN_POST_FAILURE= "LOGIN_POST_FAILURE";
export const REGISTER_POST_SUCCESS= "LOGIN_POST_SUCCESS";

// For Tasks...
export const TASK_REQUEST = "TASK_REQUEST";
export const TASK_DELETE = "TASK_DELETE";

export const TASK_FAILURE ="TASK_FAILURE";
export const POST_TASK_SUCCESS= "POST_TASK_SUCCESS";
export const GET_TASK_SUCCESS= "GET_TASK_SUCCESS";

export const PATCH_TASK_SUCCESS="PATCH_TASK_SUCCESS";
export const TOGGLE_STATUS="TOGGLE_TASK";